export default __webpack_public_path__ + "locales/az/SmartBanner.json?hash=e5f419298c1945041df38dec6b477448";